export default __webpack_public_path__ + "static/media/pravidla.aa035bbc.pdf";